import React from 'react';

import { AUTH_PATHS, BREEDER_DASHBOARD_ROOT } from 'dpl/shared/constants/urls';
import { getSafeRedirectPath, addQueryToUrl } from 'dpl/util/queryString';

const { BREEDER_SIGNUP, LOGIN, SIGNUP } = AUTH_PATHS;
export default function UserAuthHeaderLink() {
  const { pathname } = window.location;

  if ([BREEDER_SIGNUP, SIGNUP].includes(pathname)) {
    const redirectTo = getSafeRedirectPath();

    return (
      <p className="UserAuthHeaderLink UserAuthHeaderLink--login white f3 fw-medium">
        Already have an account?&nbsp;
        <a
          href={
            redirectTo
              ? addQueryToUrl({ redirect_to: redirectTo }, AUTH_PATHS.LOGIN)
              : AUTH_PATHS.LOGIN
          }
          className="underline"
        >
          Sign in
        </a>
      </p>
    );
  }

  const redirectTo = getSafeRedirectPath() || '';

  if (pathname === LOGIN && redirectTo.startsWith(BREEDER_DASHBOARD_ROOT)) {
    return (
      <p className="UserAuthHeaderLink UserAuthHeaderLink--breederSignup white f3 fw-medium">
        Are you a responsible breeder?&nbsp;
        <a href={AUTH_PATHS.BREEDER_SIGNUP} className="underline">
          Sign Up
        </a>
      </p>
    );
  }

  return null;
}
